
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    loadingOverlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 50
    },
    main: {
        position: 'relative',
        paddingTop: '124px'
    },
    main_noHero: {
        position: 'relative',
        paddingTop: '124px'
    },
    mainContentWrapper: {
        position: 'relative',
        width: '100%',
        zIndex: 0,
        '@media (min-width: 1128px)': {
            width: '66%'
        },
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '100%'
        }
    },
    mainContentWrapperFullWidth: {
        position: 'relative',
        width: '100%',
        zIndex: 0
    },
    mapSearch: {
        top: '124px',
        bottom: '0px',
        left: '0px',
        right: '0px'
    },
    pageContainer: {
        margin: '0 auto',
        position: 'relative',
        paddingLeft: '24px',
        paddingRight: '24px'
    },
    pageContainer_boxedWidth: {
        maxWidth: '1080px'
    },
    pageContainer_fullWidth: {
        maxWidth: 'none'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/styles.js